<style lang="scss" scoped>
.page {
  width: 100vw;
  height: 100vh;
  background: #000;
  background-size: contain;
  .bg {
    width: auto;
    height: 100vh;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
  }
  > div {
    width: 480px;
    height: 440px;
    padding: 55px 50px 0;
    box-sizing: border-box;
    background: #fff;
  }
}
.title {
  font-size: 20px;
  line-height: 26px;
  margin-bottom: 50px;
  .link {
    color: #173bcf;
    font-size: 14px;
  }
}
.line {
  margin-bottom: 18px;
}
.s {
  line-height: 20px;
}
</style>

<template>
  <div class="page" @click="show = true">
    <img src="@/assets/socialon_web.jpg" class="bg" />
    <transition name="el-fade-in">
      <div class="center" v-if="show">
        <div class="title clearfix">
          <div class="fl">账号登录</div>
          <!-- <router-link class="link fr" to>我要注册</router-link> -->
        </div>
        <div class="line">
          <el-input
            type="number"
            prefix-icon="el-icon-s-custom"
            v-model="form.mobile"
            placeholder="手机号"
            maxlength="11"
          ></el-input>
        </div>
        <div class="line">
          <el-input
            prefix-icon="el-icon-date"
            v-model="form.password"
            type="password"
            placeholder="登录密码"
          ></el-input>
        </div>
        <div class="line">
          <drag-verify
            :width="380"
            :height="32"
            text="请将滑块拖动到右侧"
            success-text="验证成功"
            background="rgba(0,0,0,.1)"
            progressBarBg="#17CFB8"
            text-size="14px"
            success-icon="fa fa-angle-double-right"
            ref="Verify"
          ></drag-verify>
        </div>
        <div class="s clearfix">
          <div class="fl">
            <el-checkbox label="记住密码" v-model="form.remember"></el-checkbox>
          </div>
          <router-link class="fr" to>忘记密码？</router-link>
        </div>
        <div class="btn alignc mt50">
          <el-button type="primary" @click="save">登 录</el-button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import store from 'store';
import dragVerify from 'vue-drag-verify';
import utils from '@/utils.js';
export default {
  components: {
    dragVerify,
  },
  computed: {},
  data() {
    return {
      show: false,
      form: {
        mobile: '',
        password: '',
        remember: false,
      },
    };
  },
  methods: {
    async save() {
      if (!this.$refs.Verify.isPassing) {
        this.$message.error('请先完成验证');
        return;
      } else if (!this.form.mobile || !this.form.password) {
        this.$message.error('请完善信息');
        return;
      } else {
        let res = await this.$http.post('/api/user/login', this.form);
        store.set('token', res.token);
        store.set('mobile', res.mobile);
        store.set('nickName', res.nickName);
        if (this.form.remember) {
          store.set('password', res.password);
        }
        this.$router.push('/');
      }
    },
  },
  mounted() {
    this.form.mobile = store.get('mobile');
    this.form.password = store.get('password');
  },
};
</script>
